/**
 * @prettier
 */
import { SendInvite } from "./SendInvite";

export default SendInvite;
